import { ChangeDetectorRef, Component, ElementRef, inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { filter, Subscription } from "rxjs";
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import * as fromApp from "../../store/app.reducer";
import { CustomerModel } from "../../models/customer.model";
import { EmployeeModel } from "../../models/employee.model";
import { AssignmentModel } from "../../models/assignment.model";
import { PaginationModel } from "../../models/pagination.model";
import * as AssignmentsActions from './store/assignments.actions';
import * as SharedAction from '../../shared-store/shared.actions'
import * as CompanyActions from '../company/store/company.actions';
import { JobPlaceModel } from "../../models/jobPlace.model";
import { SkillModel } from "../../models/skill.model";
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { ConfettiService } from 'src/app/service/confetti.service';
import confetti from 'canvas-confetti';
import { ShiftsStatusConst } from 'src/app/constants/shifts-status.const';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AssignmentsService } from 'src/app/services/assignments.service';
import { CalendarDataRefreshService } from 'src/app/services/calendar-data-refresh.service';
import { PublishedShiftModalComponent } from './assignment-shift-modal/published-shift-modal/published-shift-modal.component';
import { OngoingComponent } from './assignment-shift-modal/ongoing/ongoing.component';
import { FinishedComponent } from './assignment-shift-modal/finished/finished.component';
import { TranslateService } from '@ngx-translate/core';
import { MatMenuTrigger } from '@angular/material/menu';
import moment from 'moment';
import allLocales from '@fullcalendar/core/locales-all';
import { NavigationEnd, Router } from '@angular/router';
import { SubscribeService } from 'src/app/services/subscribe.service';
import { NavigationStateService } from 'src/app/service/navigation-state.service';
import { PusherService } from 'src/app/service/pusher.service';

@Component({
    selector: 'app-assignments',
    templateUrl: './assignments.component.html',
    styleUrls: ['./assignments.component.scss'],
    standalone: false
})
export class AssignmentsComponent implements OnInit, OnDestroy {
    // Variable declaration Start
    statusMap = this.getStatusMap();
    modalData: any
    public subscription: Subscription;
    private dataRefreshSubscription: Subscription;
    private translateLangSub: Subscription;
    private assignmentPusherSub: Subscription;
    private subscribedAssignmentCustomerId: number | null = null;
    public customer: CustomerModel;
    public employee: EmployeeModel;
    public objects: JobPlaceModel[];
    public skills: SkillModel[];
    public assignments: AssignmentModel[];
    public pagination: PaginationModel;
    public statusSearchText: string = '';
    public placeSearchText: string = '';
    public innerWidth: any;
    public dataLoading = false;
    public filterForm = new UntypedFormGroup({
        objects: new UntypedFormControl('0'),
        period: new UntypedFormControl('0'),
        skills: new UntypedFormControl('0'),
    });
    public sortDirection: 'asc' | 'desc' = 'asc';
    public sortField: 'date' | 'status' | null = 'date';
    public params: {
        key: string,
        value: string
    }[] = [];
    private currentFilters: any = {};
    isDefaultSelected = false;
    currentView: 'dayGridMonth' | 'timeGridWeek' | 'listWeek' | 'listMonth' = 'dayGridMonth';
    listDate: Date = new Date();
    currentTitle: string = '';
    durationchange: Boolean = true;
    eventCounts: { [date: string]: number } = {};
    isSelectingStart = true;
    selected = {
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month')
    };
    selectedMonthRange: any = {
        start_date: moment().startOf('month'),
        end_date: moment().endOf('month')
    };
    isOpen: boolean = false
    isJobOpen: boolean = false
    public loading: boolean = true
    highlightedDate: Date | null = null;
    private lastLoadedRange: { start: string; end: string } | null = null;
    private firstRenderDone = false;
    private _initialLoadDispatched = false;
    private _lastStoreUpdateKey = '';
    showFilter = false;
    showFilterChip = false
    panelPosition: { top: number; left: number } | null = null;
    public selectedItem: { label: string; value: any, is_default?: number } | null = null;
    rawEvents = [];
    calendarOptions: CalendarOptions;
    ranges: { [key: string]: moment.Moment[] } = {};
    currentLang: string = 'en';

    @ViewChild('fullCalendar') calendarComponent!: FullCalendarComponent;
    @ViewChild('fullCalendar', { read: ElementRef }) calendarEl!: ElementRef;
    @ViewChild('matMenu', { read: ElementRef }) matMenu!: ElementRef;
    @ViewChild('filterMenuTrigger') filterMenuTrigger!: MatMenuTrigger;
    private calendarResizeObserver: ResizeObserver | null = null;
    appliedFilterRange: { start: string; end: string } | null = null;

    localeData: any;
    //Calendar View option setting management
    setCalendarOptions(lang: string) {
        this.currentLang = lang;
        this.calendarOptions = {
            initialView: 'dayGridMonth',
            fixedWeekCount: false,
            locales: allLocales,
            locale: lang,
            firstDay: 1,
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            headerToolbar: false,
            showNonCurrentDates: true,
            views: {
                timeGridWeek: {
                    dayHeaderFormat: { day: 'numeric', weekday: 'short' },
                }
            },
            slotMinTime: '08:00:00',
            slotMaxTime: '18:00:00',
            slotDuration: '01:00:00',
            allDaySlot: false,
            weekends: true,
            editable: false,
            selectable: false,
            height: 'auto',
            contentHeight: 'auto',
            expandRows: true,

            eventContent: (arg) => {
                const event = arg.event;
                const props = event.extendedProps;
                const statusClass = props.status;
                const hiredUsers = (props.hired || [])
                    .slice(0, 2)
                    .map((user: any) => {
                        const initials =
                            (user.aliasName?.charAt(0)
                                ? user.aliasName.charAt(0)
                                : user.firstName?.charAt(0)
                                    ? user.firstName.charAt(0)
                                    : '-');
                        const avatar = user.image
                            ? `<img src="${user.image}" alt="${user.aliasName ? user.aliasName : user.firstName}" loading="lazy" />`
                            : `<div class="img-fallback">${initials.toUpperCase()}</div>`;

                        return `<div>
                        ${avatar}
                        <p>${user.aliasName ? user.aliasName : user.firstName}</p>
                    </div>`;
                    })
                    .join('');

                return {
                    html: `
            <div class="cursor-pointer tableStatus ${statusClass?.class}">
                <div class="tableStatus-head">
                    <h3>${event.title}</h3>
                    <i>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke="#6B7280" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </i>
                </div>

                <h4 class="capitalize">${statusClass?.label}</h4>
                <h5>${props.startTime} - ${props.endTime}</h5>
               <p style="color: #58686e;">
               ${props.guardCount || 0} 
                  ${props.guardCount > 1
                            ? this.translate.instant('assignments.guardsBooked')
                            : this.translate.instant('assignments.guardBooked')}
                </p>
                    <div class="tableStatus-user">
                    ${hiredUsers} 
                    ${props.hired.length > 2 ? `<span>+${props.hired.length - 2}</span>` : ''}
                </div>
            </div>
              `
                };
            },
            eventClick: this.onEventClick.bind(this),
            datesSet: this.onDatesSet.bind(this)
        };
        // for filter calendar
        const isSwedish = lang === 'sv';
        moment.locale(isSwedish ? 'sv' : 'en-gb');

        // Force update of days & months in selected locale
        const daysOfWeek = moment.weekdaysMin();
        const monthNames = moment.months();

        this.localeData = {
            format: 'D MMM YYYY',
            applyLabel: isSwedish ? 'Tillämpa' : 'Apply',
            cancelLabel: isSwedish ? 'Avbryt' : 'Cancel',
            customRangeLabel: isSwedish ? 'Anpassat intervall' : 'Custom range',
            daysOfWeek,
            monthNames,
            firstDay: 1,
        };

        this.ranges = isSwedish
            ? {
                'Idag': [moment(), moment()],
                'Denna vecka': [moment().startOf('week'), moment().endOf('week')],
                'Denna månad': [moment().startOf('month'), moment().endOf('month')]
            }
            : {
                'Today': [moment(), moment()],
                'This week': [moment().startOf('week'), moment().endOf('week')],
                'This month': [moment().startOf('month'), moment().endOf('month')]
            };
        moment.locale(isSwedish ? 'sv' : 'en-gb');
    }
    //Color for differen status
    calendarColorOptions: any[] = [
        { status: 'finished', borderColor: '#9FAEB9', bgColor: '#EAEDF1' },
        { status: 'published', borderColor: '#3970F4', bgColor: '#E0E6F9' },
        { status: 'on-going', borderColor: '#1BC57B', bgColor: '#DBF3DF' },
        { status: 'canceled', borderColor: '#FF2351', bgColor: '#F2E8EC' },
        { status: 'ready', borderColor: '#FFA11E', bgColor: '#F3E8DB' }
    ]
    readonly range = new FormGroup({
        start: new FormControl<string | null>(null),
        end: new FormControl<string | null>(null),
    });
    items: any[] = [{
        label: 'test', selected: false
    },
    ];
    readonly dialog = inject(MatDialog);

    // Variable declaration end
    constructor(private store: Store<fromApp.AppState>,
        private sanitizer: DomSanitizer,
        private translate: TranslateService,
        private confettiService: ConfettiService,
        public shiftsStatus: ShiftsStatusConst,
        private assignmentsService: AssignmentsService,
        private calendarDataRefreshService: CalendarDataRefreshService,
        private router: Router,
        private subscriberService: SubscribeService,
        private cdr: ChangeDetectorRef,
        private navState: NavigationStateService,
        private ngZone: NgZone,
        private pusherService: PusherService
    ) {
        this.setCalendarOptions(this.translate.currentLang);

        // Listen for language changes (day-count chips + status labels are DOM/static snapshots otherwise)
        this.translateLangSub = this.translate.onLangChange.subscribe((event) => {
            this.setCalendarOptions(event.lang);
            this.statusMap = this.getStatusMap();
            this.statusItems = [
                { label: this.translate.instant('assignments.status.finished'), value: this.shiftsStatus.FINISHED },
                { label: this.translate.instant('assignments.status.publish'), value: this.shiftsStatus.PUBLISH },
                { label: this.translate.instant('assignments.status.on-going'), value: this.shiftsStatus.ONGOING },
                { label: this.translate.instant('assignments.status.canceled'), value: this.shiftsStatus.CANCELED },
                { label: this.translate.instant('assignments.status.ready'), value: this.shiftsStatus.READY },
                { label: this.translate.instant('assignments.status.requesting-approval'), value: this.shiftsStatus.REQUESTING_APPROVAL }
            ];
            this.refreshCalendarAfterLanguageChange();
        });
    }

    ngAfterViewInit() {
        this.cdr.detectChanges();

        setTimeout(() => {
            if (this.currentView === 'listWeek' || this.currentView === 'listMonth') {
                this.scrollToCurrentDate();
            } else if (this.currentView === 'dayGridMonth') {
                this.scrollToCurrentWeek();
            }
        }, 300);

        this.setupCalendarResizeObserver();
    }

    private setupCalendarResizeObserver(): void {
        const sidenavContent = document.querySelector('mat-sidenav-content');
        const calendarNativeEl = this.calendarEl?.nativeElement;

        if (!sidenavContent && !calendarNativeEl) return;

        this.calendarResizeObserver = new ResizeObserver(() => {
            this.ngZone.runOutsideAngular(() => {
                if (this.calendarComponent && this.currentView === 'dayGridMonth') {
                    this.calendarComponent.getApi().updateSize();
                }
            });
        });

        if (sidenavContent) {
            this.calendarResizeObserver.observe(sidenavContent);
        }
        if (calendarNativeEl) {
            this.calendarResizeObserver.observe(calendarNativeEl);
        }
    }

    // Angular Lifecycle Start
    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        if (this.innerWidth <= 768) {
            this.changeView('timeGridWeek');
            this.scrollToCurrentDate();
            this.durationchange = false;
        } else {
            this.changeView('dayGridMonth');
            this.durationchange = true;
            setTimeout(() => {
                if (this.calendarComponent) {
                    const calendarApi = this.calendarComponent.getApi();
                    calendarApi.changeView('dayGridMonth', this.listDate);
                }
            });
        }

        const { start_date, end_date } = this.getMonthRange(new Date());
        this.range.setValue({ start: start_date, end: end_date });

        this.subscription = this.store.subscribe(appState => {
            const previousCustomerId = this.customer?.id;
            const nextCustomer = appState.auth.customer;
            const switchedCustomer =
                nextCustomer?.id != null &&
                previousCustomerId != null &&
                previousCustomerId !== nextCustomer.id;
            if (switchedCustomer) {
                this.selectedItem = null;
                this.selectedSkills = [];
                this.placeSearchText = '';
                this.isOpen = false;
                this.isJobOpen = false;
                this.filterForm.patchValue({ objects: '0' });
                this.updateChips();
                this.store.dispatch(new CompanyActions.LoadObjects({ customerId: nextCustomer.id }));
                this.store.dispatch(new SharedAction.LoadSkills({ customerId: nextCustomer.id }));
            }
            this.customer = nextCustomer;
            this.employee = appState.auth.employee;
            this.dataLoading = appState.assignments.assignmentsLoading;
            this.assignments = appState.assignments.assignments;
            if (switchedCustomer) {
                this.buildAndDispatchFilters();
            }

            this.syncAssignmentPusherChannel();

            // Avoid double refresh when navigating from landing: skip first empty render when we're about to load job offers
            if (this.customer && !this.assignments?.length && (this.dataLoading || !this._initialLoadDispatched)) {
                return;
            }

            // Deduplicate: only run heavy update when assignments/loading/customer/objects actually changed (avoids multiple refreshes)
            const objectsLen = appState.company?.objects?.length ?? 0;
            const updateKey = `${this.assignments?.length ?? 0}-${this.dataLoading}-${this.customer?.id ?? 'none'}-${objectsLen}`;
            if (this._lastStoreUpdateKey === updateKey) {
                return;
            }
            this._lastStoreUpdateKey = updateKey;

            this.pagination = appState.assignments.pagination;
            this.objects = appState.company?.objects ?? [];
            this.skills = appState.shared?.skills ?? [];

            this.items = (this.objects || []).map(obj => ({
                label: obj.name,
                value: obj,
                is_default: obj.is_default ? 1 : 0
            }));
            this.showFilterChip = true
            if (!this.selectedItem) {
                const defaultItem = this.items.find(i => i.value.isDefault === true);
                if (defaultItem) {
                    this.selectedItem = defaultItem;
                } else {
                    this.selectedItem = null;
                }
            }
            this.syncRawEventsAndCountsFromAssignments();
            this.renderEvents();
            setTimeout(() => this.applyDayGridCountChips(), 0);
            this.range.setValue({
                start: this.range?.value?.start ? this.range?.value?.start : start_date,
                end: this.range?.value?.end ? this.range?.value?.end : end_date
            });

            if (this.confettiService.getShowConfetti()) {
                this.showConfetti();
                this.confettiService.reset();
            }
        });

        // Subscribe to data refresh events
        this.dataRefreshSubscription = this.calendarDataRefreshService.refreshData$.subscribe(
            (refreshData) => {
                // Refresh the calendar data when any modal updates data
                this.refreshCalendarData();
            }
        );

        // Subscribe to real-time assignment updates via Pusher
        this.assignmentPusherSub = this.pusherService.assignmentUpdates$.subscribe(() => {
            this.ngZone.run(() => this.refreshCalendarData());
        });

        // Listen for navigation to same route
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                // this.refreshCalendarData();
            });

        if (this.customer) {
            this._initialLoadDispatched = true;
            this.buildAndDispatchFilters();
            this.loadAllSkills();
        }

        this.subscriberService.pageLoad$.subscribe((flag) => {
            if (this.customer) {
                this.refreshCalendarData();
                this.loadAllSkills();
                this.reloadJobPlaces();
            }
            if (this.currentView === 'dayGridMonth') {
                this.scrollToCurrentWeek();
            } else if (this.currentView === 'timeGridWeek') {
                this.scrollToCurrentDate();
            }
        });
    }

    // Angular lifecycle end
    scrollToCurrentWeek() {
        setTimeout(() => {
            const todayCell = document.querySelector('.fc-day-today') as HTMLElement;
            if (todayCell) {
                todayCell.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
                setTimeout(() => {
                    const scrollContainer = document.querySelector('.fc-daygrid-body') as HTMLElement
                        || document.querySelector('.full-calendar') as HTMLElement;
                    if (scrollContainer) {
                        scrollContainer.scrollBy({
                            top: -40,
                            behavior: 'smooth',
                        });
                    }
                }, 400);
            }
        }, 600);
    }
    scrollToCurrentDate() {
        setTimeout(() => {
            try {
                const today = new Date();
                const isMobile = window.innerWidth < 768;

                // Helper function to create pattern for a given date
                const createDatePattern = (date: Date): RegExp => {
                    const monthEn = date.toLocaleString('en-US', { month: 'short' }); // e.g., "Nov"
                    const monthSv = date.toLocaleString('sv-SE', { month: 'short' }); // e.g., "nov."
                    const day = date.getDate();
                    const year = date.getFullYear();
                    return new RegExp(
                        `(${monthEn}|${monthSv})\\.?\\s*${day},?\\s*${year}`,
                        'i'
                    );
                };

                // Helper function to find element for a given date (mobile)
                const findMobileElement = (pattern: RegExp): HTMLElement | undefined => {
                    let foundElement: HTMLElement | undefined;

                    // First, try to find by checking all mobile containers and their date spans
                    const mobileContainers = Array.from(document.querySelectorAll('.mobile-container'));
                    for (const container of mobileContainers) {
                        const dateSpan = container.querySelector('span[class*="374151"]') as HTMLElement;
                        if (dateSpan && pattern.test(dateSpan.textContent?.trim() || '')) {
                            foundElement = dateSpan;
                            break;
                        }
                    }

                    // Fallback: search all spans with the color class
                    if (!foundElement) {
                        const dateElements = Array.from(
                            document.querySelectorAll('span[class*="374151"]')
                        ) as HTMLElement[];

                        foundElement = dateElements.find((el) =>
                            pattern.test(el.textContent?.trim() || '')
                        );
                    }

                    return foundElement;
                };

                // Helper function to find element for a given date (desktop)
                const findDesktopElement = (pattern: RegExp): HTMLElement | undefined => {
                    const dateElements = Array.from(
                        document.querySelectorAll(
                            'span.font-semibold[class*="374151"], span.font-medium.text-gray-700.text-sm'
                        )
                    ) as HTMLElement[];

                    return dateElements.find((el) =>
                        pattern.test(el.textContent?.trim() || '')
                    );
                };

                // Try to find current date, if not found, go backwards day by day
                let foundElement: HTMLElement | undefined;
                let searchDate = new Date(today);
                let attempts = 0;
                const maxAttempts = 31; // Limit to prevent infinite loop

                while (!foundElement && attempts < maxAttempts) {
                    const pattern = createDatePattern(searchDate);

                    if (isMobile) {
                        foundElement = findMobileElement(pattern);
                    } else {
                        foundElement = findDesktopElement(pattern);
                    }

                    if (!foundElement) {
                        // Go back one day
                        searchDate.setDate(searchDate.getDate() - 1);
                        attempts++;
                    }
                }

                if (!foundElement) {
                    console.warn("⚠️ No matching element found for any date");
                    return;
                }

                // Scroll to the found element
                if (isMobile) {
                    // Find the mobile scroll container
                    const mobileScrollContainer = document.getElementById('mobile-scroll-container') as HTMLElement;
                    const mobileContainer = foundElement.closest('.mobile-container') as HTMLElement;

                    if (mobileScrollContainer && mobileContainer) {
                        // Calculate the position relative to the scroll container
                        const containerRect = mobileScrollContainer.getBoundingClientRect();
                        const elementRect = mobileContainer.getBoundingClientRect();
                        const scrollTop = mobileScrollContainer.scrollTop;
                        const elementTop = elementRect.top - containerRect.top + scrollTop;

                        // Scroll the container to show the element with some offset
                        mobileScrollContainer.scrollTo({
                            top: elementTop - 20, // 20px offset from top
                            behavior: 'smooth'
                        });
                    } else if (mobileContainer) {
                        mobileContainer.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    } else {
                        const y = foundElement.getBoundingClientRect().top + window.scrollY - 100;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                } else {
                    // Desktop: Use existing desktop logic
                    const scrollContainer = document.querySelector('.overflow-x-auto') as HTMLElement;

                    if (scrollContainer) {
                        foundElement.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        });
                    } else {
                        const y = foundElement.getBoundingClientRect().top + window.scrollY - 80;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                }
            } catch (err) {
                console.error("❌ Scroll to current date failed:", err);
            }
        }, 700);
    }

    private getMonthRange(date: Date): { start_date: string, end_date: string } {
        const year = date.getFullYear();
        const month = date.getMonth(); // 0-based month

        // 1️⃣ Start and end of the month
        const monthStart = new Date(year, month, 1);
        const monthEnd = new Date(year, month + 1, 0); // last day of month

        // 2️⃣ Adjust start to Monday
        const dayOfWeek = monthStart.getDay(); // 0 = Sun, 1 = Mon, ... 6 = Sat
        const diffToMonday = (dayOfWeek + 6) % 7; // converts Sunday=0 to 6
        const calendarStart = new Date(monthStart);
        calendarStart.setDate(monthStart.getDate() - diffToMonday);

        // 3️⃣ Adjust end to Sunday
        const dayOfWeekEnd = monthEnd.getDay(); // 0 = Sun, 1 = Mon, ...
        const diffToSunday = (7 - dayOfWeekEnd) % 7;
        const calendarEnd = new Date(monthEnd);
        calendarEnd.setDate(monthEnd.getDate() + diffToSunday);

        // 4️⃣ Format YYYY-MM-DD
        const formatDate = (d: Date) =>
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

        return {
            start_date: formatDate(calendarStart),
            end_date: formatDate(calendarEnd),
        };
    }

    getStatusMap() {
        return {
            [this.shiftsStatus.PUBLISH]: {
                label: this.translate.instant('assignments.status.publish'),
                class: 'published-status',
                icon: this.sanitizer.bypassSecurityTrustHtml(`
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1640_87)">
                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                        stroke="#CA8A04" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6 1C4.71612 2.34808 4 4.13837 4 6C4 7.86163 4.71612 9.65192 6 11C7.28388 9.65192 8 7.86163 8 6C8 4.13837 7.28388 2.34808 6 1Z"
                        stroke="#CA8A04" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M1 6H11" stroke="#CA8A04" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1640_87">
                        <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                    </svg>`),
                modalComponent: PublishedShiftModalComponent
            },
            [this.shiftsStatus.READY]: {
                label: this.translate.instant('assignments.status.ready'),
                class: 'ready-status',
                icon: this.sanitizer.bypassSecurityTrustHtml(`
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1641_94)">
                        <path d="M10.9013 4.99975C11.1296 6.1204 10.9669 7.28546 10.4402 8.30065C9.91352 9.31583 9.05473 10.1198 8.00704 10.5784C6.95935 11.037 5.7861 11.1226 4.68293 10.8209C3.57977 10.5192 2.61338 9.84845 1.94492 8.92046C1.27646 7.99247 0.946343 6.86337 1.00961 5.72144C1.07289 4.57952 1.52572 3.4938 2.29261 2.64534C3.05949 1.79688 4.09407 1.23697 5.22381 1.05898C6.35356 0.880989 7.51017 1.09568 8.50078 1.66725"
                        stroke="#059669" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.5 5.5L6 7L11 2" stroke="#059669" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1641_94">
                        <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                    </svg>`),
                modalComponent: PublishedShiftModalComponent
            },
            [this.shiftsStatus.ONGOING]: {
                label: this.translate.instant('assignments.status.on-going'),
                class: 'in-progress-status',
                icon: this.sanitizer.bypassSecurityTrustHtml(`
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-activity text-cyan-500">
                    <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"></path>
                    </svg>`),
                modalComponent: OngoingComponent
            },
            [this.shiftsStatus.FINISHED]: {
                label: this.translate.instant('assignments.status.finished'),
                class: 'finished-status',
                icon: this.sanitizer.bypassSecurityTrustHtml(`
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 5.25V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H8.75"
                        stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M4.5 5.5L6 7L11 2" stroke="#6B7280" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>`),
                modalComponent: FinishedComponent
            },
            [this.shiftsStatus.CANCELED]: {
                label: this.translate.instant('assignments.status.canceled'),
                class: 'canceled-status',
                icon: this.sanitizer.bypassSecurityTrustHtml(`
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1641_97)">
                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                        stroke="#EF4444" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.5 4.5L4.5 7.5" stroke="#EF4444" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.5 4.5L7.5 7.5" stroke="#EF4444" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1641_97">
                        <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                    </svg>`),
                modalComponent: PublishedShiftModalComponent
            },
            [this.shiftsStatus.REQUESTING_APPROVAL]: {
                label: this.translate.instant('assignments.status.requesting-approval'),
                class: 'requesting-approval-status',
                icon: this.sanitizer.bypassSecurityTrustHtml(`
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_requesting)">
                        <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
                        stroke="#EA580C" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6 3V6L8 7" stroke="#EA580C" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_requesting">
                        <rect width="12" height="12" fill="white" />
                        </clipPath>
                    </defs>
                    </svg>`),
                modalComponent: FinishedComponent
            }
        };
    }

    statusItems = [
        { label: this.translate.instant('assignments.status.finished'), value: this.shiftsStatus.FINISHED },
        { label: this.translate.instant('assignments.status.publish'), value: this.shiftsStatus.PUBLISH },
        { label: this.translate.instant('assignments.status.on-going'), value: this.shiftsStatus.ONGOING },
        { label: this.translate.instant('assignments.status.canceled'), value: this.shiftsStatus.CANCELED },
        { label: this.translate.instant('assignments.status.ready'), value: this.shiftsStatus.READY },
        { label: this.translate.instant('assignments.status.requesting-approval'), value: this.shiftsStatus.REQUESTING_APPROVAL }
    ];

    selectedStatus: { label: string, value: number } | null = null;
    selectedSkills: SkillModel[] = [];

    mapAssignmentToEvent(assignment: AssignmentModel) {
        return {
            id: assignment.assignmentId,
            title: assignment.title || assignment.jobPlace?.jobPlaceName || 'Untitled',
            start: assignment.startAt,
            end: assignment.endAt,
            allDay: false,
            extendedProps: {
                ...assignment,
                status: this.statusMap[assignment.status],
                guardCount: assignment.guardsHiredCount,
                borderColor: assignment.status,
                modalStatus: assignment.status,
                contactPerson: assignment.contactPersonName,
                startTime: assignment.startTime,
                endTime: assignment.endTime,
                customerImage: assignment.customerImage,
                hired: assignment.hired || []
            }
        };
    }

    resetFiltersChip() {
        this.selectedStatus = null;
        this.selectedItem = null;
        this.selectedSkills = [];
        this.showFilterChip = false;
        const { start_date, end_date } = this.getMonthRange(new Date());
        this.range.setValue({ start: start_date, end: end_date });

        this.store.dispatch(
            new AssignmentsActions.LoadCustomerJobOffers({ start_date, end_date })
        );
        this.buildAndDispatchFilters()
    }

    closeFilterMenu(): void {
        this.filterMenuTrigger?.closeMenu();
    }

    resetFilters(): void {
        const noFiltersApplied =
            !this.selectedStatus &&
            !this.selectedItem &&
            this.selectedSkills.length === 0 &&
            this.sortField === 'date' &&
            this.sortDirection === 'asc';
        if (noFiltersApplied) {
            this.closeFilterMenu();
            return;
        }
        this.selectedStatus = null;
        this.selectedItem = null;
        this.selectedSkills = [];
        this.showFilterChip = false;
        this.sortField = 'date';
        this.sortDirection = 'asc';
        const { start_date, end_date } = this.getMonthRange(new Date());
        this.range.setValue({ start: start_date, end: end_date });
        this.buildAndDispatchFilters();
        // this.store.dispatch(
        //     new AssignmentsActions.LoadCustomerJobOffers({ start_date, end_date })
        // );
        this.closeFilterMenu();
    }

    get filteredStatusItems() {
        if (!this.statusSearchText.trim()) return this.statusItems;
        return this.statusItems.filter(opt =>
            opt.label.toLowerCase().includes(this.statusSearchText.toLowerCase())
        );
    }

    get filteredPlaceItems() {
        if (!this.placeSearchText.trim()) return this.items;
        return this.items.filter(opt =>
            opt.label.toLowerCase().includes(this.placeSearchText.toLowerCase())
        );
    }

    onDateSelected(date: Date) {
        if (this.isSelectingStart) {
            this.range.setValue({ start: date.toISOString(), end: null });
            this.isSelectingStart = false;
        } else {
            const start = this.range.value.start ? new Date(this.range.value.start) : null;

            if (start && date >= start) {
                this.range.setValue({ start: start.toISOString(), end: date.toISOString() });
            } else {
                this.range.setValue({ start: date.toISOString(), end: null });
            }

            this.isSelectingStart = true;
        }
    }

    dateClass = (d: Date) => {
        const start = this.range.value.start ? new Date(this.range.value.start) : null;
        const end = this.range.value.end ? new Date(this.range.value.end) : null;

        if (!start || !end) return '';
        if (d.getTime() === start.getTime()) return 'range-start';
        if (d.getTime() === end.getTime()) return 'range-end';
        if (d > start && d < end) return 'range-middle';
        return '';
    };

    formatDate(date: string): string {
        return date.toString().split('T')[0];
    }

    toggleSkill(skill: SkillModel): void {
        const index = this.selectedSkills.findIndex(s => s.id === skill.id);
        if (index >= 0) {
            // already selected → remove
            this.selectedSkills.splice(index, 1);
        } else {
            // not selected → add
            this.selectedSkills.push(skill);
        }
    }

    loadJobOffers(start: string, end: string, extraFilters: any = {}, skipResetCheck: boolean = false): void {
        if (!this.customer?.id) return;
        this.store.dispatch(new AssignmentsActions.LoadCustomerJobOffers({
            ...extraFilters,
            start_date: start,
            end_date: end,
            job_place_id: this.selectedItem?.value?.id,
            status: this.selectedStatus?.value
        }));
        // 🔍 Check if we are still within applied filter range (skip when navigating with next/prev)
        if (!skipResetCheck && this.shouldResetFilters(start, end)) {
            this.resetFiltersChip();
            this.appliedFilterRange = null;
        }
    }

    // Helper function
    shouldResetFilters(start: string, end: string): boolean {
        if (!this.appliedFilterRange) return false; // no filter applied yet

        const currentStart = moment(start);
        const currentEnd = moment(end);
        const filterStart = moment(this.appliedFilterRange.start);
        const filterEnd = moment(this.appliedFilterRange.end);
        const isOutside =
            currentEnd.isBefore(filterStart) || currentStart.isAfter(filterEnd);

        return isOutside;
    }

    loadDefualtJobPlace(is_default, job_place_id): void {
        this.store.dispatch(new AssignmentsActions.LoadCustomerdefualtJobPlace({
            is_default: is_default,
            job_place_id: job_place_id
        }));
    }

    loadAllSkills(): void {
        if (!this.customer?.id) return;
        this.store.dispatch(new SharedAction.LoadSkills({ customerId: this.customer.id }))
    }

    private buildAndDispatchFilters() {
        if (!this.customer?.id) return;
        const payload: any = {};

        if (this.selected.startDate) {
            payload.start_date = this.selected.startDate.format('YYYY-MM-DD');
        }
        if (this.selected.endDate) {
            payload.end_date = this.selected.endDate.format('YYYY-MM-DD');
        }
        if (this.selectedSkills.length > 0) {
            payload.skill_id = this.selectedSkills.map(s => s.id);
        }
        if (this.selectedStatus) {
            payload.status = this.selectedStatus.value;
        }
        if (this.selectedItem) {
            payload.job_place_id = this.selectedItem.value.id;
        }
        this.currentFilters = payload;

        this.store.dispatch(
            new AssignmentsActions.LoadCustomerJobOffers(payload)
        );
    }

    applyFilters(): void {
        this.buildAndDispatchFilters();
        this.closeFilterMenu();
        if (!this.selected?.startDate || !this.selected?.endDate) return;
        this.appliedFilterRange = {
            start: this.selected.startDate.format('YYYY-MM-DD'),
            end: this.selected.endDate.format('YYYY-MM-DD')
        };
        setTimeout(() => {
            if (this.calendarComponent?.getApi()) {
                const api = this.calendarComponent.getApi();
                api.gotoDate(this.selected.startDate.toDate());

                if (typeof api.removeAllEvents === 'function') {
                    api.removeAllEvents();
                }
            }
        }, 50);
        this.showFilterChip = true;
    }

    removeFilter(type: string) {
        if (type === 'status') {
            this.selectedStatus = null;
        }
        if (type === 'place') {
            this.selectedItem = null;
            this.buildAndDispatchFilters()
        }
        this.updateChips();
        this.buildAndDispatchFilters();
    }

    removeSkill(index: number) {
        this.selectedSkills.splice(index, 1);
        this.updateChips();
        this.buildAndDispatchFilters();
    }

    updateChips() {
        this.showFilterChip =
            !!this.selectedStatus || !!this.selectedItem || this.selectedSkills.length > 0;
    }

    showConfetti() {
        const colors: string[] = ['#1D4ED8', '#ffffff'];
        const defaults = { colors, ticks: 200 };

        // Center burst
        confetti({
            ...defaults,
            particleCount: 120,
            spread: 70,
            origin: { y: 0.6 }
        });

        // Left angled burst
        confetti({
            ...defaults,
            particleCount: 80,
            spread: 120,
            startVelocity: 45,
            origin: { x: 0.15, y: 0.7 }
        });

        // Right angled burst
        confetti({
            ...defaults,
            particleCount: 80,
            spread: 120,
            startVelocity: 45,
            origin: { x: 0.85, y: 0.7 }
        });
    }

    private renderEvents() {
        const calendarApi = this.calendarComponent?.getApi();
        if (!calendarApi) return;

        calendarApi?.removeAllEvents();
        this.rawEvents.forEach(e => calendarApi.addEvent(e));
    }

    /** Rebuilds calendar events and per-day counts from `this.assignments` (used by store + language change). */
    private syncRawEventsAndCountsFromAssignments(): void {
        if (!this.assignments?.length) {
            this.rawEvents = [];
            this.eventCounts = {};
            return;
        }
        this.rawEvents = (this.assignments as any[]).flatMap(a =>
            (a?.events ?? []).map((e: any) => this.mapAssignmentToEvent(e))
        );
        this.eventCounts = {};
        this.rawEvents.forEach(ev => {
            const dateStr = ev?.start.split('T')[0];
            this.eventCounts[dateStr] = (this.eventCounts[dateStr] || 0) + 1;
        });
    }

    /** Orange day badges in month view; must run after FullCalendar has rendered cells. */
    private applyDayGridCountChips(): void {
        document.querySelectorAll('.event-chip').forEach(chip => chip.remove());
        const dayCells = document.querySelectorAll('.fc-daygrid-day');
        const text = this.translate.instant('assignments.list-view.assignments');
        dayCells.forEach(cell => {
            const dateStr = cell.getAttribute('data-date');
            const count = this.eventCounts[dateStr || ''] || 0;
            if (count > 1) {
                const chip = document.createElement('span');
                chip.innerText = `${count} ${text}`;
                chip.className = 'event-chip';
                cell.querySelector('.fc-daygrid-day-top')?.appendChild(chip);
            }
        });
    }

    private refreshCalendarAfterLanguageChange(): void {
        this.syncRawEventsAndCountsFromAssignments();
        setTimeout(() => {
            this.renderEvents();
            this.applyDayGridCountChips();
            this.cdr.markForCheck();
        }, 0);
    }

    onStatusSelect(status: { label: string, value: number }) {
        this.selectedStatus = status;
        this.isJobOpen = false;
    }

    toggleJobDropdown() {
        this.isJobOpen = !this.isJobOpen;
        if (this.isJobOpen) {
            this.isOpen = false;
        }
    }

    togglePlaceDropdown() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.isJobOpen = false;
        }
    }

    onDateRangeSelected(start: string, end: string) {
        this.loadJobOffers(this.formatDate(start), this.formatDate(end), this.currentFilters, true);
    }

    loadEvents() {
        const events = this.prepareGroupedEvents(this.rawEvents);
        const calendarApi = this.calendarComponent.getApi();
        events.forEach(e => calendarApi.addEvent(e));
    }

    // Opens the assignment shift modal based on the clicked calendar event's status
    onEventClick(arg: any): void {
        const event = arg.event;
        const props = event.extendedProps;
        this.modalData = props;
        const statusNumber = props.modalStatus;

        if (typeof statusNumber !== 'number') {
            console.warn('Status is not a number:', statusNumber);
            return;
        }

        const modalMap: Record<number, any> = {
            [this.shiftsStatus.ONGOING]: OngoingComponent,
            [this.shiftsStatus.FINISHED]: FinishedComponent,
            [this.shiftsStatus.PUBLISH]: PublishedShiftModalComponent,
            [this.shiftsStatus.CANCELED]: PublishedShiftModalComponent,
            [this.shiftsStatus.READY]: PublishedShiftModalComponent,
            [this.shiftsStatus.REQUESTING_APPROVAL]: FinishedComponent,
        };

        const modalComponent = modalMap[statusNumber];

        if (!modalComponent) {
            console.warn('No modal component mapped for status:', statusNumber);
            return;
        }

        const isDesktop = window.innerWidth >= 1024;

        const modalConfig: any = {
            disableClose: false,
            data: {
                title: event.title,
                ...props,
                status: statusNumber,
                isCancel: statusNumber === this.shiftsStatus.CANCELED,
                isReadyShift: statusNumber === this.shiftsStatus.READY,
                isPublishShift: statusNumber === this.shiftsStatus.PUBLISH,
                isRequestApproal: statusNumber === this.shiftsStatus.REQUESTING_APPROVAL,
            }
        };

        if (isDesktop && modalComponent !== FinishedComponent) {
            modalConfig.width = '750px';
        }
        const dialogRef = this.dialog.open(modalComponent, modalConfig);

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    prepareGroupedEvents(rawEvents: any[]): any[] {
        const grouped: { [date: string]: any[] } = {};

        for (const event of rawEvents) {
            const date = event.start.split('T')[0];
            const enddate = event.end.split('T')[0];
            if (!grouped[date]) grouped[date] = [];
            grouped[date].push(event);
        }

        const finalEvents = [];

        for (const date in grouped) {
            const events = grouped[date];
            const status = events[0].extendedProps?.status || '';
            const guardCount = events.length > 2 ? events.reduce((sum, e) => sum + (e.extendedProps?.guardCount || 0), 0) : events[0].extendedProps?.guardCount;
            const title = events.length > 2 ? `${events.length} Events` : events[0].title;
            const colors = this.calendarColorOptions.find(x => x.status == status.toLowerCase());
            finalEvents.push({
                title,
                start: date,
                // end: events[0].end,
                allDay: true,
                extendedProps: {
                    grouped: true,
                    status,
                    guardCount,
                    bgColor: colors ? colors.bgColor : '#FBBF24',
                    borderColor: colors ? colors.borderColor : '#FBBF24',
                    innerEvents: events
                },

            });
        }
        return finalEvents;
    }

    onPlaceSelect(place: { label: string; value: any }) {
        this.selectedItem = {
            label: place.label,
            value: place.value,
            is_default: place.value.isDefault ? 1 : 0
        };
        this.isOpen = false;
    }


    onDefaultToggle(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (this.selectedItem?.value?.id) {
            const isDefault = input.checked ? 1 : 0;
            this.assignmentsService.updateDefaultJobPlace(
                this.customer.id,
                { is_default: isDefault, job_place_id: this.selectedItem.value.id }
            );
            this.selectedItem = isDefault ? { ...this.selectedItem, is_default: 1 } : null;
            this.reloadJobPlaces();
        }
    }

    reloadJobPlaces() {
        this.store.dispatch(new CompanyActions.LoadObjects({ customerId: this.customer.id }));
    }

    defaultJobPlaceResponse() {
        return this.assignmentsService.defaultJobPlaceResponse();
    }

    prepareGroupedEventsForWeek(rawEvents: any[]): any[] {
        const grouped: { [dateTime: string]: any[] } = {};
        const finalEvents = [];

        for (const event of rawEvents) {
            const dateTimeKey = event.start;
            if (!grouped[dateTimeKey]) grouped[dateTimeKey] = [];
            grouped[dateTimeKey].push(event);
        }

        for (const dateTime in grouped) {
            const events = grouped[dateTime];

            const status = events[0].extendedProps?.status || '';
            const guardCount = events.length > 2 ? events.reduce((sum, e) => sum + (e.extendedProps?.guardCount || 0), 0) : events[0].extendedProps?.guardCount;
            const title = events.length > 2 ? `${events.length} Events` : events[0].title;
            const colors = this.calendarColorOptions.find(x => x.status == status.toLowerCase());
            finalEvents.push({
                title,
                start: dateTime,
                end: events[0].end,
                extendedProps: {
                    grouped: true,
                    status,
                    guardCount,
                    bgColor: colors ? colors.bgColor : '#FBBF24',
                    borderColor: colors ? colors.borderColor : '#FBBF24',
                    innerEvents: events
                }
            });
        }

        return finalEvents;
    }


    changeView(view: 'dayGridMonth' | 'timeGridWeek') {
        this.currentView = view;
        this.durationchange = view === 'dayGridMonth';

        const updateAndLoad = (date: Date) => {
            const { start_date, end_date } = this.getMonthRange(date);
            if (!start_date || !end_date) return;
            this.range.setValue({ start: start_date, end: end_date });
            this.updateListTitle(date);
            this.loadJobOffers(start_date, end_date, this.currentFilters, true);
        };

        const performScroll = () => {
            // Wait for view to be fully rendered before scrolling
            setTimeout(() => {
                if (this.currentView === 'dayGridMonth') {
                    // Scroll to current week for calendar month view
                    // Check if calendar element exists before scrolling
                    const calendarExists = document.querySelector('.fc-day-today') ||
                        document.querySelector('.fc-daygrid-body') ||
                        document.querySelector('.full-calendar');
                    if (calendarExists) {
                        this.scrollToCurrentWeek();
                    } else {
                        // Retry after a short delay if calendar not ready
                        setTimeout(() => this.scrollToCurrentWeek(), 300);
                    }
                } else if (this.currentView === 'timeGridWeek') {
                    // Scroll to current date for list view
                    // Check if list view elements exist before scrolling
                    const listViewExists = document.querySelector('.list-view') ||
                        document.querySelector('span[class*="374151"]') ||
                        document.querySelector('.mobile-container');
                    if (listViewExists) {
                        // List view is rendered, scroll now
                        this.scrollToCurrentDate();
                    } else {
                        // Retry after a delay if list view not ready
                        setTimeout(() => {
                            this.scrollToCurrentDate();
                        }, 500);
                    }
                }
            }, this.currentView === 'timeGridWeek' ? 300 : 200); // Longer delay for list view to ensure data is loaded
        };

        if (this.innerWidth <= 768) {
            this.ngZone.run(() => updateAndLoad(this.listDate || new Date()));
            performScroll();
        } else {
            // Desktop view
            if (view === 'timeGridWeek') {
                // List view - no calendar component needed
                updateAndLoad(this.listDate || new Date());
                performScroll();
            } else {
                // Calendar view - use calendar component
                setTimeout(() => {
                    if (this.calendarComponent) {
                        const calendarApi = this.calendarComponent.getApi();
                        calendarApi.changeView(view, this.listDate);
                        this.updateTitle(calendarApi);
                        updateAndLoad(calendarApi.getDate());
                        // Perform scroll after calendar view change is complete
                        performScroll();
                    }
                }, 100); // Small delay to ensure view change is initiated
            }
        }
    }

    goPrev() {
        if (this.currentView === 'dayGridMonth' && this.calendarComponent) {
            const calendarApi = this.calendarComponent.getApi();
            calendarApi.prev();
            this.updateTitle(calendarApi);
            const { start_date, end_date } = this.getMonthRange(calendarApi.getDate());
            this.selectedMonthRange = { start_date, end_date };

            this.selected = {
                startDate: moment(start_date),
                endDate: moment(end_date)
            };
            this.loadJobOffers(start_date, end_date, this.currentFilters, true);
            this.scrollToCurrentWeek();

        } else if (this.currentView === 'timeGridWeek') {
            // Move to the previous month in the list view
            this.listDate.setMonth(this.listDate.getMonth() - 1);
            this.updateListTitle(this.listDate);
            const { start_date, end_date } = this.getMonthRange(this.listDate);
            this.selectedMonthRange = { start_date, end_date };
            this.selected = {
                startDate: moment(start_date),
                endDate: moment(end_date)
            };
            this.loadJobOffers(start_date, end_date, this.currentFilters, true);
            this.scrollToCurrentDate();
        }

    }

    goNext() {
        if (this.currentView === 'dayGridMonth' && this.calendarComponent) {
            const calendarApi = this.calendarComponent.getApi();
            calendarApi.next();
            this.updateTitle(calendarApi);
            const { start_date, end_date } = this.getMonthRange(calendarApi.getDate());
            this.selectedMonthRange = { start_date, end_date };
            this.selected = {
                startDate: moment(start_date),
                endDate: moment(end_date)
            };
            this.loadJobOffers(start_date, end_date, this.currentFilters, true);
            this.scrollToCurrentWeek();
        }
        else if (this.currentView === 'timeGridWeek') {
            this.listDate.setMonth(this.listDate.getMonth() + 1);
            this.updateListTitle(this.listDate);
            const { start_date, end_date } = this.getMonthRange(this.listDate);
            this.selectedMonthRange = { start_date, end_date };
            this.selected = {
                startDate: moment(start_date),
                endDate: moment(end_date)
            };
            this.loadJobOffers(start_date, end_date, this.currentFilters, true);
        }
    }


    updateTitle(calendarApi: any) {
        const date = calendarApi.getDate();
        this.currentTitle = date.toLocaleDateString(this.currentLang || 'en', {
            month: 'long',
            year: 'numeric'
        });
    }

    updateListTitle(date: Date) {
        this.currentTitle = date.toLocaleDateString(this.currentLang || 'en', {
            month: 'long',
            year: 'numeric'
        });
    }
    onDatesSet(arg: any) {
        const calendarApi = this.calendarComponent?.getApi();
        calendarApi?.removeAllEvents();
        setTimeout(() => {
            this.currentTitle = arg.view.title;
        });

        const range = this.getMonthRange(arg.view.currentStart);
        const payload = {
            ...this.currentFilters,
            start_date: this.currentFilters.start_date ?? range.start_date,
            end_date: this.currentFilters.end_date ?? range.end_date,
        };
        if (!this.firstRenderDone) {
            this.firstRenderDone = true;
            this.lastLoadedRange = { start: payload.start_date, end: payload.end_date };
            return;
        }
        if (
            this.lastLoadedRange &&
            this.lastLoadedRange.start === payload.start_date &&
            this.lastLoadedRange.end === payload.end_date
        ) {
            return;
        }

        // ✅ Save last loaded range
        this.lastLoadedRange = { start: payload.start_date, end: payload.end_date };

        // ✅ Dispatch API call only for new month range (skip when not logged in)
        if (this.customer?.id) {
            this.store.dispatch(new AssignmentsActions.LoadCustomerJobOffers(payload));
        }
        setTimeout(() => {
            const todayCell = document.querySelector('.fc-day-today');
            if (todayCell) {
                todayCell.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }, 400); // small delay to ensure DOM is ready

    }

    ngOnDestroy() {
        this.calendarResizeObserver?.disconnect();
        this.calendarResizeObserver = null;
        this.subscription.unsubscribe();
        if (this.dataRefreshSubscription) {
            this.dataRefreshSubscription.unsubscribe();
        }
        this.translateLangSub?.unsubscribe();
        this.assignmentPusherSub?.unsubscribe();
        if (this.subscribedAssignmentCustomerId != null) {
            this.pusherService.unsubscribeFromAssignmentChannel(this.subscribedAssignmentCustomerId);
            this.subscribedAssignmentCustomerId = null;
        }
    }

    private syncAssignmentPusherChannel(): void {
        const newId = this.customer?.id ?? null;
        if (newId === this.subscribedAssignmentCustomerId) return;

        if (this.subscribedAssignmentCustomerId != null) {
            this.pusherService.unsubscribeFromAssignmentChannel(this.subscribedAssignmentCustomerId);
        }

        this.subscribedAssignmentCustomerId = newId;

        if (newId != null) {
            this.pusherService.subscribeToAssignmentChannel(newId);
        }
    }

    onNextPage(): void {
        if (this.pagination.currentPage !== this.pagination.lastPage) {
            this.store.dispatch(new AssignmentsActions.LoadAssignments({
                customerId: this.customer.id,
                page: this.pagination.currentPage + 1,
                params: this.params
            }));
        }
    }

    onPreviousPage(): void {
        if (this.pagination.currentPage !== 1) {
            this.store.dispatch(new AssignmentsActions.LoadAssignments({
                customerId: this.customer.id,
                page: this.pagination.currentPage - 1,
                params: this.params
            }));
        }
    }

    onFirstPage(): void {
        if (this.pagination.currentPage !== 1) {
            this.store.dispatch(new AssignmentsActions.LoadAssignments({
                customerId: this.customer.id,
                page: 1,
                params: this.params
            }));
        }
    }

    onLastPage(): void {
        if (this.pagination.currentPage !== this.pagination.lastPage) {
            this.store.dispatch(new AssignmentsActions.LoadAssignments({
                customerId: this.customer.id,
                page: this.pagination.lastPage,
                params: this.params
            }));
        }
    }

    public onFilter(key: string, value: any): void {
        if (value == 0) {
            this.params = this.params.filter(el => el.key != key);
        } else {
            this.params = this.params.filter(el => el.key != key);
            this.params.push({ key: key, value: value })
        }
        this.store.dispatch(new AssignmentsActions.ClearAssignments());
        this.store.dispatch(new AssignmentsActions.LoadAssignments({ customerId: this.customer.id, page: 1, params: this.params }));
    }

    stylizeEvent(info: any) {
        const props = info.event.extendedProps;
        const bgColor = props?.bgColor || '#3B82F6';

        info.el.style.backgroundColor = props?.bgColor;
        info.el.style.borderColor = props?.bgColor;
        info.el.style.color = '#000000';
        info.el.style.borderRadius = '8px';

        const today = new Date().toISOString().split('T')[0];
        const isToday = info.event.startStr.startsWith(today);
        if (isToday) {
            info.el.style.boxShadow = '0 0 6px 2px rgba(0, 0, 0, 0.1)';
        }
    }

    toggleFilterPanel() {
        this.showFilter = !this.showFilter;
    }

    //Opem modal from calendar list view 
    openStatusModal(event: any): void {
        const status = event.status;
        const modalComponent = this.statusMap[status]?.modalComponent;
        if (!modalComponent) {
            console.warn(`No modal defined for status: ${status}`);
            return;
        }

        const isDesktop = window.innerWidth >= 1024;
        const modalConfig: any = {
            disableClose: false,
            data: {
                title: event.title || '',
                ...event,
                status,
                isCancel: status === this.shiftsStatus.CANCELED,
                isReadyShift: status === this.shiftsStatus.READY,
                isPublishShift: status === this.shiftsStatus.PUBLISH,
                isRequestApproval: status === this.shiftsStatus.REQUESTING_APPROVAL,
            }
        };

        if (isDesktop && modalComponent !== FinishedComponent) {
            modalConfig.width = '750px';
        }
        const dialogRef = this.dialog.open(modalComponent, modalConfig);
    }

    filterListViewByStatusOrDate(value: string): void {
        if (value === 'date') {
            this.sortByDate();
        } else if (value === 'status') {
            this.sortByStatus();
        }
    }

    sortByDate(): void {
        if (this.sortField === 'date') {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = 'date';
            this.sortDirection = 'asc';
        }

        this.assignments = [...this.assignments].sort((a, b) => {
            const dateA = new Date((a as any).date).getTime();
            const dateB = new Date((b as any).date).getTime();

            if (this.sortDirection === 'asc') {
                return dateA - dateB;
            } else {
                return dateB - dateA;
            }
        });
    }

    sortByStatus(): void {
        if (this.sortField === 'status') {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = 'status';
            this.sortDirection = 'asc';
        }

        // Define clear status priority order for sorting
        const statusPriorityMap = new Map([
            ['Canceled', 1],
            ['Finished', 2],
            ['On-going', 3],
            ['Published', 4],
            ['Ready', 5],
            ['Requesting Approval', 6]
        ]);

        const getStatusLabel = (status: number): string => {
            const statusItem = this.statusItems.find(item => item.value === status);
            return statusItem ? statusItem.label : 'Unknown';
        };

        const getStatusPriority = (statusLabel: string): number => {
            return statusPriorityMap.get(statusLabel) || 999;
        };

        const allEventEntries: any[] = [];

        this.assignments.forEach((assignment: any) => {
            if (assignment.events && assignment.events.length > 0) {
                assignment.events.forEach((event: any) => {
                    const statusLabel = getStatusLabel(event.status || 0);
                    allEventEntries.push({
                        assignment: { ...assignment },
                        event: { ...event },
                        date: assignment.date,
                        statusLabel: statusLabel,
                        statusPriority: getStatusPriority(statusLabel)
                    });
                });
            }
        });

        allEventEntries.sort((a, b) => {
            let comparison = 0;
            if (this.sortDirection === 'asc') {
                comparison = a.statusPriority - b.statusPriority;
            } else {
                comparison = b.statusPriority - a.statusPriority;
            }
            if (comparison === 0) {
                const dateA = new Date(a.date).getTime();
                const dateB = new Date(b.date).getTime();
                comparison = dateA - dateB;
            }

            return comparison;
        });

        // Group events back into assignments while preserving sort order
        const groupedAssignments = new Map<string, any>();
        const assignmentOrder: string[] = [];

        allEventEntries.forEach(entry => {
            const assignmentKey = `${entry.date}_${entry.assignment.id || Math.random()}`;

            if (!groupedAssignments.has(assignmentKey)) {
                groupedAssignments.set(assignmentKey, {
                    ...entry.assignment,
                    events: []
                });
                assignmentOrder.push(assignmentKey);
            }

            groupedAssignments.get(assignmentKey)!.events.push(entry.event);
        });

        // Rebuild assignments array in the correct order
        this.assignments = assignmentOrder.map(key => groupedAssignments.get(key)!);
    }

    getStatusTooltip(statusId: number, reliabilityPercentage: number): string {
        if (statusId === this.shiftsStatus.PUBLISH) {
            return this.translate.instant('guard-shift-details.common.publish');
        } else if (statusId === this.shiftsStatus.READY) {
            // return this.translate.instant('guard-shift-details.common.ready');
            // Inject dynamic reliability percentage
            return this.translate.instant(
                'guard-shift-details.common.ready',
                { reliability: reliabilityPercentage ?? 0 }
            );
        } else if (statusId === this.shiftsStatus.ONGOING) {
            return this.translate.instant('guard-shift-details.common.ongoing');
        } else if (statusId === this.shiftsStatus.FINISHED) {
            // Inject dynamic reliability percentage
            return this.translate.instant(
                'guard-shift-details.common.finished',
                { reliability: reliabilityPercentage ?? 0 }
            );
        } else if (statusId === this.shiftsStatus.CANCELED) {
            return this.translate.instant('guard-shift-details.common.canceled');
        } else if (statusId === this.shiftsStatus.REQUESTING_APPROVAL) {
            return this.translate.instant('guard-shift-details.common.requesting-approval',
                { reliability: reliabilityPercentage ?? 0 }
            );
        }
        else {
            return this.translate.instant('guard-shift-details.common.unknown');
        }
    }

    /**
     * Refresh calendar data using current filters
     */
    private refreshCalendarData() {
        let start_date: any;
        let end_date: any;

        if (this.selectedMonthRange?.start_date) {
            start_date = moment(this.selectedMonthRange.start_date).format('YYYY-MM-DD');
        }

        if (this.selectedMonthRange?.end_date) {
            end_date = moment(this.selectedMonthRange.end_date).format('YYYY-MM-DD');
        }

        this.dispatchFiltersWithDates(start_date, end_date);
    }

    private dispatchFiltersWithDates(start_date?: string, end_date?: string) {
        if (!this.customer?.id) return;
        // Preserve applied filters (job_place_id, status, skill_id) when refreshing after shift update or date navigation
        const payload: any = { ...this.currentFilters };
        // use provided start_date & end_date if passed, otherwise fall back to selected
        if (start_date) {
            payload.start_date = start_date;
        } else if (this.selected.startDate) {
            payload.start_date = this.selected.startDate.format('YYYY-MM-DD');
        }

        if (end_date) {
            payload.end_date = end_date;
        } else if (this.selected.endDate) {
            payload.end_date = this.selected.endDate.format('YYYY-MM-DD');
        }
        // Keep filter fields in sync with component state so they persist until user resets
        if (this.selectedItem) {
            payload.job_place_id = this.selectedItem.value.id;
        }
        if (this.selectedStatus) {
            payload.status = this.selectedStatus.value;
        }
        if (this.selectedSkills?.length) {
            payload.skill_id = this.selectedSkills.map(s => s.id);
        }
        this.currentFilters = payload;

        this.store.dispatch(
            new AssignmentsActions.LoadCustomerJobOffers(payload)
        );
    }

    getassignmentsTotalCount(): number {
        if (!this.eventCounts || Object.keys(this.eventCounts).length === 0) {
            return 0;
        }
        return Object.values(this.eventCounts).reduce((total, count) => total + count, 0);
    }

    onCreateAssignment(): void {
        // Make sure we start clean
        this.navState.setBackNavigation(false);
        this.store.dispatch(new AssignmentsActions.UpdateStep(1));

        this.router.navigate(['/components/assignments/create-assignment/step1']);
    }
}   
